module.exports = __webpack_public_path__ + "59c141923f2832f57fa1f30d6fbd1628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic1.png
// module id = 1853
// module chunks = 0